<template>
    <transition name="headerSlide">
        <!--   -->
        <div v-show="showMessage && message" class="last-order-notice"
             :style="{position: 'fixed', top: `${topPos}px`, left: 0}"
             ref="lastOrderNotice"
             id="lastOrderNotice"
        >
            <p class="content-last-order-date">  <i class=" prz-info"/> {{message}} </p>
        </div>
    </transition>
</template>

<script>
import request from '@/Utilities/httpRequest';
import {storeHeader} from '@/store/mobileNavigation/header';

export default {
    storeHeader,
    name: 'lastOrderDate',
    props: {
        groupId:{
            type: String,
            default: ''
        },
        url: {
            type: String,
            default: null
        },
        timeOut: {
            type: Number,
            default: 5000
        }
    },
    data(){
        return{
            topPos: 116,
            message: '',
            showMessage: false
        }
    },
    created() {
        this.initializer();
    },
    methods: {
        initializer(){
            this.load();
        },
        calcTopPos() {
            const headerSearchBar = document.getElementById('header_search_bar');
            if(headerSearchBar) {
                this.topPos = headerSearchBar.getBoundingClientRect().y + headerSearchBar.getBoundingClientRect().height;
                //console.log('top pos: ', this.topPos);
            }
        },
        attachInHeader(message = '') {
            this.calcTopPos();
            document.addEventListener("scroll", this.calcTopPos);
            setTimeout(() => {
                this.message = message;
                this.showMessage = true;
                setTimeout(() => {
                    this.showMessage = false;
                    document.removeEventListener("scroll", this.calcTopPos);
                }, this.timeOut) ;
            }, 1000);

            /*const lastOrderWrapper = document.getElementById('lastOrderWrapper');
            const lastOrderNotice = document.getElementById('lastOrderNotice');
            if(lastOrderWrapper && lastOrderNotice) {
                lastOrderWrapper.append(lastOrderNotice);
                setTimeout(() => {
                    this.message = message;
                    this.showMessage = true;
                    setTimeout(() => {
                        //this.showMessage = false;
                        //this.$emit('destroy');
                    }, this.timeOut) ;
                }, 1000);
            }*/
        },
        async load(){
            const { data } = await request.get(this.url,{id: this.groupId});
            if (!data || !data.hasOwnProperty("result") || !data.result.hasOwnProperty("ajaxParams") || data.result.ajaxParams === null){
                return;
            }
            const ajaxParams = data.result.ajaxParams;
            if (ajaxParams.hasOwnProperty("message") && ajaxParams.message !== "") {
                this.attachInHeader(ajaxParams.message);
            }
        }
    }
}
</script>

<style lang="scss">
@import '../../../scss/CalcSize.scss';
    .last-order-notice {
        position: fixed;
        top: 116px;
        left: 0;
        display: block;
        height: 48px;
        background: #6F6F6F;
        color: #fff;
        z-index: 120;
        width: 100vw;
       /* left: 50%;
        right: 50%;
        margin-left: -50vw;
        margin-right: -50vw;*/

        .content-last-order-date {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            padding: 4px 42px;
            gap: 8px;
            font-size: responsive(16px);
            font-weight: 600;
            line-height: 1.25;
        }

        i {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 16px;
            height: 16px;
            font-size: responsive(16px);
        }
    }

    .headerSlide-enter-active, .headerSlide-leave-active {
        transition: all 0.25s linear;
    }
    
    .headerSlide-enter,
    .headerSlide-leave-to {
        transform: translateY(-100%);
    }

@media screen and (max-width: $bkp-s-end) {
    .last-order-notice {
        height: 32px;
        .content-last-order-date {
            font-size: responsive(12px);
            line-height: 1.16;
        }
    }
}

@media screen and (min-width: $bkp-m-start) and (max-width: $bkp-m-end) {
    .last-order-notice {
        height: 40px;
        .content-last-order-date {
            font-size: responsive(12px);
            line-height: 1.16;
        }
    }
}


</style>
